import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const Pending = () => {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="card text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
            <svg className="h-10 w-10 text-yellow-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>

          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Account Pending Approval
          </h2>

          <p className="text-gray-600 mb-6">
            Thank you for registering{user && `, ${user.firstName}`}! Your account is currently pending approval.
          </p>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6 text-left">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-yellow-700">
                  <strong>What's next?</strong>
                </p>
                <ul className="mt-2 text-sm text-yellow-700 list-disc list-inside space-y-1">
                  <li>Our team will review your registration</li>
                  <li>You'll receive an email once approved</li>
                  <li>You can then access your customer portal</li>
                </ul>
              </div>
            </div>
          </div>

          {user && user.email && (
            <p className="text-sm text-gray-500 mb-6">
              We'll send the approval notification to <strong>{user.email}</strong>
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/" className="btn-outline">
              Return Home
            </Link>
            <button
              onClick={() => window.location.href = 'mailto:info@vigilantedge.tech?subject=Account%20Approval%20Inquiry'}
              className="btn-secondary"
            >
              Contact Support
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Pending
